<template>
	<b-modal :id="id" :visible="visible" hide-footer hide-header no-close-on-backdrop no-close-on-esc>
		<b-container class="text-center">
			<b-row class="my-4">
				<b-col class="text-justify" v-html="message"></b-col>
			</b-row>
			<b-row class="my-4">
				<b-col>
					<elumin-loader/>
				</b-col>
			</b-row>
		</b-container>
	</b-modal>
</template>

<script>
	export default
	{
		name: 'processing-modal',
		props: [ 'id', 'visible', 'message' ],
		data () { return {}; }
	}
</script>
